export const impactStats = [
  { label: "Load Time Improvement", value: "40%", description: "via code splitting & memoization" },
  { label: "Test Coverage", value: "90%", description: "with Jest & RTL" },
  { label: "SonarQube Issues Resolved", value: "3000+", description: "code quality improvements" },
  { label: "Test Cases Written", value: "2000+", description: "comprehensive test suites" }
];
